<template>
  <div id="ul-buttons">
    <label
      v-if="inputData.label"
      :for="`dynamicInput-${inputData.id}`"
      v-html="addNbsp(getLocaleText(inputData.label))"
    />
    <v-row>
      <v-col
        v-for="(value, key) in inputData.values"
        :key="key"
        cols="12"
        sm="6"
        :data-cy="`UlButtons_${
          dependentInputs(inputData, inputValue, formName).length
            ? 'withDependentInput'
            : 'withoutDependentInput'
        }`"
      >
        <div
          v-if="value.htmlClass === 'self'"
          class="ul-button ul-button--family_box rounded pa-4 cursor-pointer border"
          :class="{ selected: inputValue === value.id }"
          @click="updateValue(value.id)"
        >
          <v-img
            width="56"
            contain
            :src="$asset('img/icons/person-happy.svg')"
            class="mb-4"
            eager
          />
          <div class="text-h3">
            {{ getLocaleText(value.value) }}
          </div>
        </div>
        <div
          v-else-if="value.htmlClass === 'others'"
          class="ul-button ul-button--family_box rounded pa-4 cursor-pointer border"
          :class="{ selected: inputValue === value.id }"
          @click="updateValue(value.id)"
        >
          <v-img width="56" contain :src="$asset('img/icons/care.svg')" class="mb-4" eager />
          <div class="text-h3">
            {{ getLocaleText(value.value) }}
          </div>
        </div>
        <div
          v-else
          class="ul-button ul-button--button px-4 py-3 border cursor-pointer rounded d-flex align-center white"
          :class="{
            selected: inputValue !== null && inputValue === value.id,
            'error--text': $v.inputValue.$error
          }"
          @click="updateValue(value.id)"
        >
          <v-icon class="mr-2" size="16" :color="$v.inputValue.$error ? 'error' : 'grey-darken-1'">
            {{ inputValue !== null && inputValue === value.id ? '$radioOn' : '$radioOff' }}
          </v-icon>
          <span>{{ getLocaleText(value.value) }}</span>
          <v-spacer />
          <v-icon class="align-self-end primary--text">
            {{ inputValue !== null && inputValue === value.id ? '$tick' : '' }}
          </v-icon>
        </div>
      </v-col>
    </v-row>
    <div v-for="(input, index) in dependentInputs(inputData, inputValue, formName)" :key="index">
      <DynamicFormInput
        v-if="showInput(input, formName)"
        :key="input.id + index"
        class="dynamic-form-input mb-4"
        :input-data="input"
        :form-name="formName"
        store="abc"
      />
    </div>
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';
import { required } from 'vuelidate/lib/validators';
import dynamicForms from '@/mixins/dynamicForms';
export default {
  name: 'UlButtons',
  mixins: [formGtm, dynamicForms],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: null
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        inputValue: { required }
      };
    }
    return { inputValue: {} };
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    if (this.responses[this.formName][this.inputData.id]) {
      this.updateValue(+this.responses[this.formName][this.inputData.id], false);
    }

    this.reset();
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    reset() {
      if (this.$v) {
        this.$v.$reset();
      }
    },
    updateValue(id, emit = true) {
      this.$v.inputValue.$model = id;
      this.validate();
      const updateResponsePayload = {
        id: this.inputData.id,
        value: this.inputValue,
        formName: this.formName
      };

      this.$store.dispatch('dynamicForms/updateResponse', updateResponsePayload);
      if (emit) {
        this.$emit('update:value');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#ul-buttons {
  .ul-button {
    transition: all 0.2s ease-in-out;

    &--family_box {
      &:hover,
      &:focus,
      &:active {
        border-color: $primary !important;
      }
    }

    &--button {
      &.error--text {
        background-color: rgba($error, 0.05) !important;
      }

      &:hover,
      &:focus,
      &:active {
        background-color: $grey !important;
      }
    }

    &.selected {
      border-color: $primary !important;
    }

    &.error--text {
      border-color: $error !important;
    }
  }
}
</style>
